import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { createSubscription } from "src/store/subscriptions/saga";
import * as Yup from "yup";

const SubscriberAddForm = ({
  open,
  onHide,
  onSuccessClick,
}: {
  open: boolean;
  onHide: () => void;
  onSuccessClick: (message: string) => void;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <FormDrawer
      drawerProps={{ isOpen: open, onHide, title: t("Subscriptions.AddButton").toString() }}
      onHide={onHide}
      loader
      initialValues={{ Email: "", Name: "", Locale: "tr" }}
      validationSchema={Yup.object().shape({
        Email: Yup.string().email(t("Validation.Email", "Geçerli e-posta girin").toString()).required(t("Validation.Required").toString()),
      })}
      onSubmit={(values) => {
        dispatch(
          createSubscription({
            payload: {
              onSuccess: (message: string) => {
                onHide();
                onSuccessClick(message);
              },
              onError: (message: string) => toast.error(message, { theme: "colored" }),
            },
            body: values,
          })
        );
      }}
      inputs={[
        { field: "Email", label: t("Subscriptions.Email").toString() },
        { field: "Name", label: t("Subscriptions.Name").toString() },
        { field: "Locale", label: t("Subscriptions.Locale").toString() },
      ]}
    />
  );
};
export default SubscriberAddForm;
